import React from "react";
import CustomPopup from "../../../../Common/CustomPopup";
import OutlineButton from "../../../../Common/Buttons/OutlineButton";
import { formatRescheduleDate, isMathSubject } from "../../../helpers.js";
import styles from "./index.module.css";
import checkCircleLine from "../../../../../assets/images/checkCircleLine.svg";

const ReschedulePopup = ({
  open,
  onClose,
  subject = "Math",
  rescheduleDate,
  timezoneValue = "Asia/Calcutta",
  timeZoneList = [],
  onKnowMentor,
  onEvaluationTest,
  onLearningActivity,
}) => {
  const formattedDate = formatRescheduleDate(
    rescheduleDate,
    timezoneValue,
    timeZoneList,
  );
  const recommendations = [
    {
      id: 1,
      linkText: "Take an evaluation test",
      desc: "Assess your subject knowledge before the trial class",
      onClick: onEvaluationTest,
      mathOnly: true,
    },
    {
      id: 2,
      linkText: "Know your mentor better",
      desc: "Check out your demo mentor's profile to get a bit more familiar",
      onClick: onKnowMentor,
    },
    {
      id: 3,
      linkText: "Doing a learning activity",
      desc: "Start learning a topic - bite sized lessons everyday go a long way!",
      onClick: onLearningActivity,
    },
  ].filter((rec) => !rec?.mathOnly || isMathSubject(subject));

  return (
    <CustomPopup
      open={open}
      onClose={onClose}
      maxWidth="md"
      className={styles.reschedulePopup}
      showCloseButton={true}
      disableBackdropClick={false}
    >
      <div className={styles.container}>
        <h2 className={styles.title}>
          Your trial class for {subject} has been rescheduled to{" "}
          <span className={styles.dateHighlight}>{formattedDate}</span>.
        </h2>

        <div className={styles.recommendSection}>
          <p className={styles.recommendLabel}>
            While you wait, we recommend you to:
          </p>
          <div className={styles.recList}>
            {recommendations.map((rec) => (
              <div key={rec?.id} className={styles.recItem}>
                <img
                  src={checkCircleLine}
                  alt=""
                  className={styles.checkIcon}
                />
                <div className={styles.recContent}>
                  <button className={styles.recLink} onClick={rec?.onClick}>
                    {rec?.linkText}
                  </button>
                  <p className={styles.recDesc}>{rec?.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <OutlineButton
          onClick={() => window.location.reload()}
          className={styles.ctaBtn}
        >
          Great! I'll check it out
        </OutlineButton>
      </div>
    </CustomPopup>
  );
};

export default ReschedulePopup;
